import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch, shallowEqual, useSelector } from 'react-redux';
import { actions as agentFeedbackActions } from 'features/AgentFeedback';

const useLinks = () => {
  const dispatch = useDispatch();
  const { links, actionProcessing } = useSelector(state => state.agentFeedback, shallowEqual);

  const [state, setState] = useState({
    links: {}, // { feedback: { link, is_visible }, promociones: { ... } }
  });

  const onChangeLink = useCallback((type, value) => {
    setState(prev => ({
      ...prev,
      links: {
        ...prev.links,
        [type]: {
          ...prev.links?.[type],
          link: value,
        },
      },
    }));
  }, []);

  useEffect(() => {
    setState(prev => ({
      ...prev,
      links: links || {},
    }));
  }, [links]);

  const handleFormSubmit = useCallback(
    (e, type) => {
      e.preventDefault();

      const currentLink = state.links?.[type]?.link || '';

      dispatch(agentFeedbackActions.updateFeedbackLink(type, currentLink));
    },
    [dispatch, state.links],
  );

  return {
    state,
    onChangeLink,
    handleFormSubmit,
    actionProcessing,
  };
};

export default useLinks;
